import isImageFile from './isImageFile'

export default (input, callBack) => {
  const { files = null } = input
  if (files === null) {
    return
  }

  const [firstFile = null] = files

  if (firstFile === null || !isImageFile(firstFile)) {
    return
  }

  const reader = new FileReader()

  reader.onload = e => {
    callBack(e.target.result)
  }
  reader.readAsDataURL(firstFile)
}
